import { buildQueryContext, QueryMode } from '@superset-ui/core';
import { CalendarChartFormData } from './types';

export default function buildQuery(formData: CalendarChartFormData) {
  const dimensions = (formData.groupby || []).filter(Boolean).slice(0, 2);
  const metrics = (formData.metrics || []).filter(Boolean).slice(0, 1);
  const hasMetric = metrics.length > 0;

  return buildQueryContext(formData, baseQueryObject => [
    {
      ...baseQueryObject,
      is_timeseries: false,
      query_mode: hasMetric ? QueryMode.Aggregate : QueryMode.Raw,
      columns: dimensions,
      metrics,
      row_limit: Number(formData.row_limit) || 10000,
    },
  ]);
}

